export type LotAvailabilityStatusId = 'disponible' | 'option' | 'reserve' | 'vendu';

export type LotAvailabilityMeta = {
  id: LotAvailabilityStatusId;
  label: string;
  badgeClass: string;
};

export const LOT_AVAILABILITY_STATUSES: LotAvailabilityMeta[] = [
  { id: 'disponible', label: 'Disponible', badgeClass: 'bg-emerald-100 text-emerald-800' },
  { id: 'option', label: 'Option', badgeClass: 'bg-amber-100 text-amber-800' },
  { id: 'reserve', label: 'Réservé', badgeClass: 'bg-blue-100 text-blue-800' },
  { id: 'vendu', label: 'Vendu', badgeClass: 'bg-slate-200 text-slate-700' },
];

export function normalizeLotAvailabilityStatus(raw?: string | null): LotAvailabilityStatusId {
  const s = String(raw || 'disponible').trim().toLowerCase();
  if (s === 'disponible' || s === 'option' || s === 'reserve' || s === 'vendu') {
    return s;
  }
  return 'disponible';
}

export function lotAvailabilityMeta(id: LotAvailabilityStatusId): LotAvailabilityMeta {
  return LOT_AVAILABILITY_STATUSES.find((s) => s.id === id) ?? LOT_AVAILABILITY_STATUSES[0];
}

/** Lots affichés sur la vitrine (catalogue + fiche programme). */
export function isLotVisibleOnVitrine(status?: string | null): boolean {
  const id = normalizeLotAvailabilityStatus(status);
  return id === 'disponible' || id === 'option';
}
